var MuiDialogContent = {
    /* put your new default props here */
    dividers: true,
};
export default MuiDialogContent;
//# sourceMappingURL=MuiDialogContent.js.map